import Base from './base'
import urls from 'config/urls'

class Category extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.category.find,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.category.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.category.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.category.delete,
      data: opts
    })
  }
}

export default new Category



// WEBPACK FOOTER //
// ./src/models/category.js